'use strict'

let cid

// welcome
//------------------------------------------------------------
$(function(){
  // ようこそ！滋賀へ
  if( $("body").is("#welcome") && $("body").is(".about") ){
    $.fn.extend({
      wlStickyCheckers: function(){
        var parent = $(this);
        $("[data-mapid]", parent).on('tap', function(){
          var cid = $(this).data("mapid");
          window.location.hash = cid;
        });
        $("[data-mapid]", parent).hover(
          function(){
            cid = $(this).data("mapid");
            parent.attr("data-current", cid);
          },
          function(){
            cid = $(this).data("mapid");
            parent.attr("data-current", "");
          }
        );
      }
    });
    $(function(){
      $(".map-link").wlStickyCheckers();
    });
  }
});



// WEBPACK FOOTER //
// ./_src/js/cont/welcome.js